import { Paper, Popover } from "@material-ui/core";
import makeStyles from "@material-ui/styles/makeStyles";
import dynamic from "next/dynamic";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { useAuth, useLoginPopupState } from "hooks/authHooks";
import { useState } from "react";
import { SignedinState } from "components/enums/SignedinState";
import { useOTP } from "components/OTPProvider";

const DynamicSignIn = dynamic(
  () =>
    import("components/SignIn").then(
      (defaultComponent) => defaultComponent.SignIn
    ),
  { ssr: false }
);

const DynamicAphDialogClose = dynamic(
  () =>
    import("components/web-ui-components/AphDialogClose").then(
      (defaultComponent) => defaultComponent.default
    ),
  { ssr: false }
);

const useStyles = makeStyles((theme: Theme) => {
  return {
    popOver: {
      "&>div:first-child": {
        background: "rgba(0,0,0,0.5) !important",
      },
    },
    topPopover: {
      overflow: "initial",
      backgroundColor: "none",
      boxShadow: "none",
    },
    loginForm: {
      width: 340,
      padding: 20,
      borderRadius: 10,
      boxShadow: "0 5px 40px 0 rgba(0, 0, 0, 0.3)",
      backgroundColor: theme.palette.common.white,
      minHeight: 240,
      [theme.breakpoints.down("xs")]: {
        width: 300,
      },
    },
  };
});

interface ILoginPopupProps {
  anchorRef?: Element | ((element: Element) => Element);
}

const LoginPopup = (props: ILoginPopupProps) => {
  const { isSignedIn } = useAuth();
  const { setVerifyOtpError } = useOTP();
  const classes = useStyles({});
  const { isLoginPopupVisible, setIsLoginPopupVisible } = useLoginPopupState();
  const [mobileNumber, setMobileNumber] = useState<string>("");
  const [otp, setOtp] = useState<string>("");

  const { anchorRef } = props;
  return (
    isSignedIn === SignedinState.SIGNEDOUT && (
      <Popover
        open={isLoginPopupVisible}
        anchorEl={anchorRef}
        onClose={() => {
          const otpAfterCleaning = otp.replace(/,/g, "");
          if (
            mobileNumber.length ||
            (mobileNumber.length === 10 && otpAfterCleaning.length) ||
            otpAfterCleaning.length === 6
          ) {
            setIsLoginPopupVisible(false);
            setVerifyOtpError(false);
          }
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        classes={{
          root: classes.popOver,
          paper: classes.topPopover,
        }}
      >
        <DynamicAphDialogClose
          onClick={() => setIsLoginPopupVisible(false)}
          title={"Close"}
          style={{ top: 5, right: 5 }}
        />
        <Paper className={classes.loginForm}>
          <DynamicSignIn
            setMobileNumber={(mobileNumber: string) =>
              setMobileNumber(mobileNumber)
            }
            setOtp={(otp: string) => setOtp(otp)}
            mobileNumber={mobileNumber}
            otp={otp}
          />
        </Paper>
      </Popover>
    )
  );
};

export default LoginPopup;
